





















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "BaseInputBox",
  props: {
    hasSecondPrepend: { type: Boolean, default: false },
    hasSecondAppend: { type: Boolean, default: false },
    hasAppend: { type: Boolean, default: false },
    hasPrepend: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
});
